import {
  getPackageListApi,
  getPayCodeApi,
  getPayCodeUrlApi,
  confirmPayInfoApi,
  getTokenPlanApi,
  getPointPlanApi,
  getUserTokensApi,
  getSubscribePackageListApi,
  getDelSubscribePackageListApi,
} from "./api/pay";
import { isDesktop } from "./utils";

const pay = {
  intervalTimer: null,
  async getUserTokens() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await getUserTokensApi();
        const data = res.data;
        if (data.code >= 300) {
          reject({
            code: data.code,
            msg: data.msg,
          });
        }
        resolve(data.data);
      } catch (e) {
        reject({
          msg: e.msg || "获取用户token失败",
        });
      }
    });
  },
  async getTokenPlan() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await getTokenPlanApi();
        const data = res.data;
        if (data.code >= 300) {
          reject({
            code: data.code,
            msg: data.msg,
          });
        }
        resolve(data.data);
      } catch (e) {
        reject({
          msg: e.msg || "获取token方案失败",
        });
      }
    });
  },
  async getPointPlan() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await getPointPlanApi();
        const data = res.data;
        if (data.code >= 300) {
          reject({
            code: data.code,
            msg: data.msg,
          });
        }
        resolve(data.data);
      } catch (e) {
        reject({
          msg: e.msg || "获取积分方案失败",
        });
      }
    });
  },
  async getPackageList() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await getPackageListApi();
        const data = res.data;
        if (data.code >= 300) {
          reject({
            code: data.code,
            msg: data.msg,
          });
        }
        resolve(data.data);
      } catch (e) {
        reject({
          msg: e.msg || "获取套餐列表失败",
        });
      }
    });
  },
  async getDelSubscribePackageList(delId) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await getDelSubscribePackageListApi(delId);
        const data = res.data;
        if (data.code >= 300) {
          reject({
            code: data.code,
            msg: data.msg,
          });
        }
        resolve(data.data);
      } catch (e) {
        reject({
          msg: "请求失败",
        });
      }
    });
  },
  async getSubscribePackageList() {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await getSubscribePackageListApi();
        const data = res.data;
        if (data.code >= 300) {
          reject({
            code: data.code,
            msg: data.msg,
          });
        }
        resolve(data.data);
      } catch (e) {
        reject({
          msg: "请求失败",
        });
      }
    });
  },
  async getPayCode(plan_type, goods_id, code) {
    const type = isDesktop();
    if (type != 4) {
      if (type == 0) {
        return await this.getPayCodeUrl(plan_type, goods_id, code);
      } else {
        return await this.getPayQrCode(plan_type, goods_id, code);
      }
    }
  },
  async getPayQrCode(plan_type, goods_id, code) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await getPayCodeApi(plan_type, goods_id, code);
        const data = res.data;
        if (data.code >= 300) {
          reject({
            code: data.code,
            msg: data.msg,
          });
        }
        resolve(data.data);
      } catch (e) {
        reject({
          msg: e.msg || "获取支付二维码失败",
        });
      }
    });
  },
  async getPayCodeUrl(plan_type, goods_id, code) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await getPayCodeUrlApi(plan_type, goods_id, code);
        const data = res.data;
        if (data.code >= 300) {
          reject({
            code: data.code,
            msg: data.msg,
          });
        }
        resolve({ ...data.data, mobile: true });
      } catch (e) {
        reject({
          msg: e.msg || "获取支付二维码失败",
        });
      }
    });
  },
  async payPoll(order_id) {
    let overTime = 60;
    const that = this;

    //获取支付结果
    const confirmPayInfo = async () => {
      return new Promise(async (resolve) => {
        try {
          const res = await confirmPayInfoApi(order_id);
          const data = res.data;
          if (data.code >= 300) {
            resolve({
              status: 0,
              msg: data.msg,
            });
          }
          const payData = data.data.status;
          resolve({
            status: payData.code,
            msg: payData.msg,
          });
        } catch (e) {
          resolve({
            status: 0,
            msg: e.msg || "获取支付结果失败",
          });
        }
      });
    };

    return new Promise((resolve, reject) => {
      that.intervalTimer = setInterval(async () => {
        if (overTime <= 0) {
          reject({
            status: 0,
            msg: "支付失败",
          });
          clearInterval(that.intervalTimer);
        } else {
          overTime -= 2;
          const res = await confirmPayInfo();
          if (res.status === 1) {
            clearInterval(that.intervalTimer);
            resolve({
              status: 1,
              msg: "支付成功",
            });
          }
        }
      }, 2000);
    });
  },

  // 停止轮询二维码登录
  stopInterval() {
    clearInterval(this.intervalTimer);
  },
};

export default pay;
